import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const GoogleIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="03.source" transform="translate(-448.000000, -144.000000)">
                <g
                    id="Google_-G-_Logo"
                    transform="translate(448.000000, 144.000000)"
                >
                    <g id="Clipped">
                        <mask id="mask-2" fill="white">
                            <path d="M23.7227268,9.81818182 L12.2799997,9.81818182 L12.2799997,14.4545455 L18.866545,14.4545455 C18.2525451,17.4 15.6849087,19.0909091 12.2799997,19.0909091 C8.26109073,19.0909091 5.02363625,15.9272727 5.02363625,12 C5.02363625,8.07272727 8.26109073,4.90909091 12.2799997,4.90909091 C14.0103633,4.90909091 15.5732724,5.50909091 16.8012724,6.49090909 L20.3736359,3 C18.1967269,1.14545455 15.4058178,0 12.2799997,0 C5.4701817,0 0,5.34545455 0,12 C0,18.6545455 5.4701817,24 12.2799997,24 C18.4199996,24 24.0018177,19.6363636 24.0018177,12 C24.0018177,11.2909091 23.8901813,10.5272727 23.7227268,9.81818182 Z" />
                        </mask>
                        <polygon
                            id="Shape"
                            fill="#FBBC05"
                            fillRule="nonzero"
                            mask="url(#mask-2)"
                            points="-1.11636361 19.0909091 -1.11636361 4.90909091 8.37272709 12"
                        />
                    </g>
                    <g id="Clipped">
                        <mask id="mask-4" fill="white">
                            <path d="M23.7227268,9.81818182 L12.2799997,9.81818182 L12.2799997,14.4545455 L18.866545,14.4545455 C18.2525451,17.4 15.6849087,19.0909091 12.2799997,19.0909091 C8.26109073,19.0909091 5.02363625,15.9272727 5.02363625,12 C5.02363625,8.07272727 8.26109073,4.90909091 12.2799997,4.90909091 C14.0103633,4.90909091 15.5732724,5.50909091 16.8012724,6.49090909 L20.3736359,3 C18.1967269,1.14545455 15.4058178,0 12.2799997,0 C5.4701817,0 0,5.34545455 0,12 C0,18.6545455 5.4701817,24 12.2799997,24 C18.4199996,24 24.0018177,19.6363636 24.0018177,12 C24.0018177,11.2909091 23.8901813,10.5272727 23.7227268,9.81818182 Z" />
                        </mask>
                        <polygon
                            id="Shape"
                            fill="#EA4335"
                            fillRule="nonzero"
                            mask="url(#mask-4)"
                            points="-1.11636361 4.90909091 8.37272709 12 12.2799997 8.67272727 25.6763631 6.54545455 25.6763631 -1.09090909 -1.11636361 -1.09090909"
                        />
                    </g>
                    <g id="Clipped">
                        <mask id="mask-6" fill="white">
                            <path d="M23.7227268,9.81818182 L12.2799997,9.81818182 L12.2799997,14.4545455 L18.866545,14.4545455 C18.2525451,17.4 15.6849087,19.0909091 12.2799997,19.0909091 C8.26109073,19.0909091 5.02363625,15.9272727 5.02363625,12 C5.02363625,8.07272727 8.26109073,4.90909091 12.2799997,4.90909091 C14.0103633,4.90909091 15.5732724,5.50909091 16.8012724,6.49090909 L20.3736359,3 C18.1967269,1.14545455 15.4058178,0 12.2799997,0 C5.4701817,0 0,5.34545455 0,12 C0,18.6545455 5.4701817,24 12.2799997,24 C18.4199996,24 24.0018177,19.6363636 24.0018177,12 C24.0018177,11.2909091 23.8901813,10.5272727 23.7227268,9.81818182 Z" />
                        </mask>
                        <polygon
                            id="Shape"
                            fill="#34A853"
                            fillRule="nonzero"
                            mask="url(#mask-6)"
                            points="-1.11636361 19.0909091 15.6290906 6.54545455 20.0387268 7.09090909 25.6763631 -1.09090909 25.6763631 25.0909091 -1.11636361 25.0909091"
                        />
                    </g>
                    <g id="Clipped">
                        <mask id="mask-8" fill="white">
                            <path d="M23.7227268,9.81818182 L12.2799997,9.81818182 L12.2799997,14.4545455 L18.866545,14.4545455 C18.2525451,17.4 15.6849087,19.0909091 12.2799997,19.0909091 C8.26109073,19.0909091 5.02363625,15.9272727 5.02363625,12 C5.02363625,8.07272727 8.26109073,4.90909091 12.2799997,4.90909091 C14.0103633,4.90909091 15.5732724,5.50909091 16.8012724,6.49090909 L20.3736359,3 C18.1967269,1.14545455 15.4058178,0 12.2799997,0 C5.4701817,0 0,5.34545455 0,12 C0,18.6545455 5.4701817,24 12.2799997,24 C18.4199996,24 24.0018177,19.6363636 24.0018177,12 C24.0018177,11.2909091 23.8901813,10.5272727 23.7227268,9.81818182 Z" />
                        </mask>
                        <polygon
                            id="Shape"
                            fill="#4285F4"
                            fillRule="nonzero"
                            mask="url(#mask-8)"
                            points="25.6763631 25.0909091 8.37272709 12 6.13999987 10.3636364 25.6763631 4.90909091"
                        />
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default GoogleIcon;
